/**
 * A request URL as it may be written to a log line: the share card's token path segment and every query
 * value are replaced, because some of those carry credentials (a share card's token, a pack invite inside a
 * `deepLink`). The path and the query keys are kept, which is what a log reader needs to tell routes apart.
 */
function loggableUrl(url) {
  const raw = String(url || '');
  const queryAt = raw.indexOf('?');
  const path = queryAt === -1 ? raw : raw.slice(0, queryAt);
  const query = queryAt === -1 ? '' : raw.slice(queryAt + 1);
  const redactedPath = path.replace(/^\/s\/[^/]+/, '/s/<redacted>');
  if (!query) {
    return redactedPath;
  }
  const keys = query
    .split('&')
    .filter(Boolean)
    .map((pair) => `${pair.split('=')[0]}=<redacted>`);
  return `${redactedPath}?${keys.join('&')}`;
}

module.exports = { loggableUrl };
